import {Component, inject, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {NgbModal, NgbTooltipModule} from "@ng-bootstrap/ng-bootstrap";
import {environment} from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {ApplicationService} from '../services/application.service';
import {NgIf} from '@angular/common';

@Component({
    selector: 'help-button',
    templateUrl: './help-button.component.html',
    styleUrls: ['./help-button.component.css'],
    imports: [
        NgbTooltipModule,
        NgIf
    ]
})
export class HelpButtonComponent implements OnChanges {
  @Input() field: string;
  @Input() showText = false;

  @ViewChild('content') content;
  title: string
  helpText: string
  http = inject(HttpClient);
  loaded = false;
  // @Input() helpPromise: Promise<any>;
  constructor(private modalService: NgbModal, public appService: ApplicationService) {}

  ngOnChanges({field}: SimpleChanges) {
    if (field?.currentValue) {
      this.getHelpText(field.currentValue);
    }
  }

  getHelpText(field: string): void {
    this.loaded = false;
    this.appService.getHelp(field).subscribe((help: any) => {
      this.title = help.help_label;
      this.helpText = help.help_text;
      this.loaded = true;
    });
  }

  open(content, event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.modalService.open(content, {ariaLabelledBy: this.title, centered: true, size: 'lg'});
  }
}
